import { get } from 'lodash';
import { WorkOrderTaskType } from '@xbcb/work-order-types';
import { WorkOrderTaskStatus } from '__generated__/graphql';

// find a work order task on a work order that matches the task query string in the URL
export const findMatchingWorkOrderTask = (
  workOrderRecord: any,
  taskType: string,
) => {
  const workOrderTasks = get(workOrderRecord, 'tasks', []);
  const matchingTasks = workOrderTasks.filter((task: any) => {
    const workOrderTaskType = get(task, 'definition.workOrderTaskType', '');
    return taskType === workOrderTaskType;
  });

  if (matchingTasks.length <= 1) {
    return matchingTasks[0];
  }

  // Apply non-COMPLETED logic only for specific task types
  const specialTaskTypes: string[] = [
    WorkOrderTaskType.US_IOR_CONTINUOUS_BOND_CHARGE_BOND_RENEWAL_EXCEPTION,
    WorkOrderTaskType.US_IOR_CONTINUOUS_BOND_VERIFY_RENEWAL_EXCEPTION,
  ];

  if (specialTaskTypes.includes(taskType)) {
    return (
      matchingTasks.find(
        (task: any) => get(task, 'status') !== WorkOrderTaskStatus.COMPLETED,
      ) || matchingTasks[0]
    );
  }

  return matchingTasks[0];
};
